import * as Sentry from '@sentry/vue'

/** Low-cardinality product counters for Sentry Application Metrics. */

export function trackPageView(routeName: string): void {
  Sentry.metrics.count('navigation.page_view', 1, {
    attributes: { route: routeName },
  })
}

export function trackBookingCreated(source: 'guest' | 'provider'): void {
  Sentry.metrics.count('booking.created', 1, {
    attributes: { source },
  })
}

export function trackBookingCreateFailed(source: 'guest' | 'provider'): void {
  Sentry.metrics.count('booking.create_failed', 1, {
    attributes: { source },
  })
}

export function trackOnboardingStep(questionKey: string): void {
  Sentry.metrics.count('onboarding.step_completed', 1, {
    attributes: { question_key: questionKey },
  })
}

export function trackOnboardingCompleted(): void {
  Sentry.metrics.count('onboarding.completed', 1)
}

export function trackConnectivityChange(online: boolean): void {
  Sentry.metrics.count('app.connectivity_change', 1, {
    attributes: { status: online ? 'online' : 'offline' },
  })
}
